import VideoTplLegacy from "../VideoTplLegacy";
import {
    customCommand, VideoBridgeGetFileInfo,
    VideoBridgeReadyStatusHasReady,
    VideoBridgeReadyStatusNotReady,
    VideoBridgeReportUrls
} from "../../../api";
import {
    callDeveloperClicked,
    callDeveloperDismissed,
    callDeveloperEndCardShowSuccess,
    callDeveloperPlayCompleted,
    callDeveloperShowFailed,
    callDeveloperShowSucccess
} from "../../../api/noticeDeveloperAPI";
import {
    onSubPlayTemplateViewCloseBtnClicked,
    onSubPlayTemplateViewLoad,
    onComponentReactDeveloperCallbackCLICKED,
    onComponentReactDeveloperCallbackDISMISSED,
    onComponentReactDeveloperCallbackENDCARDSHOWSUCCESS,
    onComponentReactDeveloperCallbackPLAYCOMPLETED,
    onComponentReactDeveloperCallbackPLAYFAILED,
    onComponentReactDeveloperCallbackPLAYSUCCESS
} from "../../../api/componentReactListener";
import {_isPad, _fnIsPortrait} from "../../../common/m_base/util";
import {checkCreateResOK} from "../../../api/apiUtil";
import BigTpl from "../BigTpl";

/**
 * mintegral SDK 大模板
 */
export default class BigTplChoseFromTwo extends BigTpl {

    constructor(...props) {
        super(...props)

        // 表明当前模板如果要成功加载, 至少需要多少个 campaign
        this.expectCampaignNumber = 2
        // 用来存储当前用户选择的, 将要进行播放的子模板
        this.currentChildTpl = null
        // 存储通过当前大模板创建的子模板索引列表
        this.childTplList = []

        // 以下为初始化时通过 SDK 获取到的上下文环境变量,
        this.campaignList = null
        this.sdkInfo = null
        this.unitId = null
        this.appSetting = null
        this.unitSetting = null
        this.sdkSetting = null
        this.device = null
        this.bigTemplateInstanceId = null
        this.rootViewInstanceId = null
        this.playVideoMute = null
    }

    async init({JsBridgeRes}) {
        super.init({JsBridgeRes})

        // 从 SDK 获取 campaign 列表, 和当前环境的上下文信息
        await this.initSDKContext()

        // 如果当前从 SDK 获取到的 campaign 数量满足模板渲染要求
        if (this.isCampaignReady()) {

            this.videoTplLegacy = new VideoTplLegacy({MTG_SDKContext})

            // 批量创建并预加载 "播放模板" 视图 (Native)
            await this.batchCreateVideoTemplateLegacy()

            // 两个 type 模板实例创建成功之后, 批量添加模板 preload 的事件监听
            this.addPreloadFinishEventListener()

            // preload URL
            await this.batchPreloadVideoTemplateLegacy()

        } else {
            console.warn('当前 campaign 不满足模板初始化条件, 请检查.', {campaignList: this.campaignList})
            VideoBridgeReadyStatusNotReady({
                errMessage: '当前 campaign 不满足模板初始化条件, 请检查',
                errDetail: `campaign length: ${this.campaignList && this.campaignList.length}, ready 状态: ${this.campaignList && this.campaignList.forEach && this.campaignList.forEach(item => item.isReady)}`
            })
        }

        this.initComponents()
    }

    isCampaignReady() {
        let campaignReadyState = false
        let campaignList = this.campaignList
        let isCampaignLengthFulfilled = campaignList && campaignList.length === this.expectCampaignNumber
        if (isCampaignLengthFulfilled) {
            let needAllCampaignVideoLoadConditionFulfilled = campaignList[0] && campaignList[0].nscpt
            console.log({needAllCampaignVideoLoadConditionFulfilled})
            // needAllCampaignVideoLoadConditionFulfilled 为 1 的情况下, 需要要求所有 campaign 的 video 加载达到 rate 值(默认 100%), 才可以认为广告 ready
            if (needAllCampaignVideoLoadConditionFulfilled) {
                campaignReadyState = campaignList.filter(item => item.isReady).length === this.expectCampaignNumber
            }
                // needAllCampaignVideoLoadConditionFulfilled 为 0 的情况下, 任意一个 campaign 的 video 加载达到 rate 值(默认 100%), 就可以认为广告 ready
            // 所以在 needAllCampaignVideoLoadConditionFulfilled=0 的情况下, 大模板首次加载通过 init 拿到的 offer 有可能只有一个 offer 为 ready 状态
            else if (!needAllCampaignVideoLoadConditionFulfilled) {
                campaignReadyState = campaignList.filter(item => item.isReady).length >= 1
            } else {
                campaignReadyState = false
                console.warn('needAllCampaignVideoLoadConditionFulfilled 配置异常, 无法确定当前广告的 ready 状态', {
                    campaignList,
                    nscpt: needAllCampaignVideoLoadConditionFulfilled
                })
            }
        }
        // 基础的 campaign 长度不符合二选一模板要求
        else {
            campaignReadyState = false
            console.warn('基础的 campaign 长度不符合二选一模板要求', {campaignList})
        }
        return campaignReadyState
    }

    updateSDKContext(key, value) {
        if (typeof key === 'undefined') {
            console.warn('更新 SDKContext 失败, 请传入有效的 key 值')
            return false
        }

        this[key] = value
        if (this.MTG_SDKContext) {
            this.MTG_SDKContext[key] = value
        }
        return this.MTG_SDKContext
    }

    /**
     * 渲染大模板的静态 UI 部分
     */
    renderPageStaticUI({readyCampaignList} = {}) {

        console.log('---------- 注册用户交互事件监听 start ----------')
        // 在大模板中预先初始化用户交互事件所需的 Handler
        this.registerPageHandler()

        // 准备渲染页面所需的数据
        let dataForRender = {
            campaignList: this.formatCampaignList(readyCampaignList),
            isPad: _isPad(),
            isPortrait: _fnIsPortrait(),
        };
        console.log({dataForRender})

        // 渲染页面
        window.MTG_RENDER(dataForRender)
    }

    /**
     * 批量创建 type4 模板实例
     * @returns {Promise<void>}
     */
    async batchCreateVideoTemplateLegacy() {
        for (let campaign of this.campaignList) {
            console.log('jsBridge._callNative({fnName: \'operateComponent\', params})')
            let createRes = await this.videoTplLegacy
                .create({campaign})
                .catch(err => {
                    console.warn('创建 Native 播放模板异常: ', {err})
                    VideoBridgeReadyStatusNotReady({
                        errMessage: '创建 Native 播放模板异常',
                        errDetail: JSON.stringify(err || {})
                    })
                })

            if (checkCreateResOK(createRes)) {
                console.warn('创建 Native 播放模板成功: ', {createRes})
                // 关联 campaign 和 原生组件
                this.addToTemplateList(campaign.id, createRes.data.id);
            } else {
                console.warn('创建 Native 播放模板失败: ', {createRes})
            }

        }
    }

    /**
     * 将创建成功的播放模板添加到子模板列表中, 并绑定对应的 campaign
     * @param campaignId 要绑定的 campaign id
     * @param createdInstanceId 当前创建成功的子模板实例 id
     */
    addToTemplateList(campaignId, createdInstanceId) {
        this.childTplList.push({
            campaignId: campaignId,
            tplInstanceId: createdInstanceId,
            isPageLoadFinished: false,
        })
        console.log('childTplList: ', this.childTplList)
    }

    addPreloadFinishEventListener() {
        for (let curTplItem of this.childTplList) {
            let expectCmptId = curTplItem && curTplItem.tplInstanceId
            // preload finish 回调 401
            onSubPlayTemplateViewLoad({
                expectCmptId,
                cb: ({id, data} = {}) => {

                    // 加载失败或超时
                    if (data && data.result !== 1) {
                        let resultConf = {
                            1: '成功',
                            2: '失败',
                            3: '超时',
                        }
                        let errMessage = `当前模板加载${resultConf[data.result]}: `;
                        console.warn(errMessage, {id, data})
                        VideoBridgeReadyStatusNotReady({
                            errMessage,
                            errDetail: `当前实例 id: ${id}, 返回的 data: ${JSON.stringify(data)}`,
                        })
                        return false
                    }

                    // 加载成功
                    curTplItem.isPageLoadFinished = true
                    console.warn('=-= -------------------- preload 成功, 当前 load 成功的模板实例为: ', {id, data})
                    console.log('=-= 当前所有模板的 load 状态: ', this.childTplList)

                    // 给当前模板添加 2345 开发者回调事件监听
                    console.log('---------- 注册开发者回调监听 start ----------')
                    // 在大模板中预先初始化开发者回调所需的 Handler
                    this.registerDeveloperCallbackHandler({expectCmptId})
                    console.log('---------- 注册开发者回调监听 end ----------')

                    // 给当前模板添加关闭按钮回调
                    console.log('---------- 注册用户点击关闭按钮监听 start ----------')
                    this.registerEndCardCloseButtonHandler({expectCmptId});
                    console.log('---------- 注册用户点击关闭按钮监听 end ----------')

                    // 判断如果所有模板都 preload 成功, 则执行下一步 (addSubView/回调 SDK ready)
                    if (this.allTplPreloadFinished()) {

                        console.warn('------------------------------ =-= 所有模板 preload 成功 ------------------------------')

                        console.log('---------- 上报 HasReady start ----------')
                        // 检查所有模板是否都已经 preload finished, 如果是则通知 SDK ready
                        VideoBridgeReadyStatusHasReady()
                        console.log('---------- 上报 HasReady end ----------')

                    } else {
                        console.log('已经加载成功了一个模板, 但还有 1 个模板正在加载中...', this.childTplList)
                    }
                }
            })
        }
    }

    async batchPreloadVideoTemplateLegacy() {
        for (let curTplItem of this.childTplList) {
            if (!curTplItem.isPageLoadFinished) {
                console.log(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 调用开始: ', {curTplIndex: curTplItem})
                let preloadRes = await this.videoTplLegacy
                    .preload({id: curTplItem && curTplItem.tplInstanceId})
                    .catch(err => {
                        console.warn(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 异常', {err})
                        VideoBridgeReadyStatusNotReady({
                            errMessage: 'preload 异常',
                            errDetail: JSON.stringify({curTplItem, err})
                        })
                    })
                if (preloadRes && preloadRes.code === 0) {
                    console.log(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 调用成功----------', {
                        preloadRes,
                        curTplItem
                    })
                } else {
                    console.warn(curTplItem.campaignId, curTplItem.tplInstanceId, 'preload 失败', {
                        preloadRes,
                        curTplItem
                    })
                    VideoBridgeReadyStatusNotReady({
                        errMessage: 'preload 失败',
                        errDetail: JSON.stringify({curTplItem, preloadRes})
                    })
                }
            }
        }
    }

    /**
     * 监听 type4 广告 endcard 阶段, triggerCloseBtn 被触发时 SDK 发出的事件通知
     * 接到通知时, 由 H5 调用 SDK API 通知开发者 dismissed 回调, 之后无论回调成功失败超时, 都需要调用 API 关闭当前广告
     */
    registerEndCardCloseButtonHandler({expectCmptId}) {
        // 1. componentReact 402
        console.warn('|||||||||| 1. start - 注册用户点击关闭按钮监听: componentReact 402')
        onSubPlayTemplateViewCloseBtnClicked({
            expectCmptId,
            cb: async ({id, data}) => {

                // 2. reactDeveloper type 6
                console.warn('|||||||||| 2. start - "用户点击关闭按钮事件" 被触发, 即将调用开发者 dismissed 回调: reactDeveloper type 6')
                // type 4 类型广告被关闭, 调用 SDK API 通知开发者 dismissed 回调: data.convert // 1/2(成功/失败)
                let developerCallbackResult = await callDeveloperDismissed({
                    unitId: this.unitId,
                    data
                })
                console.warn('|||||||||| 2. end - 调用开发者 dismissed 回调完成', {developerCallbackResult})

                // 3. operate 402
                console.warn('|||||||||| 3. start - 即将调用最终的 closeAd : operate 402')
                let closeResult = await this.videoTplLegacy.close({id})
                console.warn('|||||||||| 3. end - 调用最终的 closeAd 完成: operate 402')
            }
        })
        console.warn('|||||||||| 1. end - 注册用户点击关闭按钮监听: componentReact 402')
    }

    /**
     * 在收到特定 SDK 事件时通知 SDK 给开发者展示广告阶段的回调
     * 当前支持的开发者回调 type:
     *      1: showsuccess， // 开发者调用 show 成功
     *      2: showfailed (error)， // 开发者调用 show 失败
     *      3: playcompleted， // 视频播放完毕
     *      4: endcardshowsuccess， // endcard 成功展示
     *      5: clicked， // 通过点击 cta button 或其他方式触发的 install 时触发
     *      6: dismissed（boolean convert） // endcard 被关闭
     */
    registerDeveloperCallbackHandler({expectCmptId}) {
        console.warn('--------------- 在收到特定 SDK 事件时通知 SDK 给开发者展示广告阶段的回调')

        let unitId = this.unitId

        onComponentReactDeveloperCallbackPLAYSUCCESS({
            expectCmptId,
            cb: ({id, data}) => {
                console.warn('onComponentReactDeveloperCallbackPLAYSUCCESS')
                // 注意: SDK 针对 "type 4 类型" 的原生视图了特殊定制,
                //  与老版本的 RewardVideo 在开发者回调方面有以下区别:
                //  1. 老版本的 RewardVideo 会在视频开始播放时同时上报 only_impression_url 和 impression_url (即 PV), 且会主动发 showsuccess
                //  2. 新版本 SDK 大模板流程中的 "type 4 类型" 在视图被展示且自动开始播放时只会上报 impression_url, 且不会主动发 showsuccess
                //  因为按照二选一模板的逻辑, showsuccess 开发者回调在大模板的 webviewshow 阶段就需要调用了,
                //  这里需要无视 SDK 发出的 showsuccess, 二选一模板在收到此类型 componentReact 时不作处理即可
                // // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
                // callDeveloperShowSucccess({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackPLAYFAILED({
            expectCmptId,
            cb: ({id, data}) => {
                // 大模板展示失败时, 调用 SDK API 通知开发者 showerror 回调
                callDeveloperShowFailed({unitId, data}) /* data: {error: data.error} */
            }
        })

        onComponentReactDeveloperCallbackPLAYCOMPLETED({
            expectCmptId,
            cb: ({id, data}) => {
                // "type 4 类型" 广告播放完成时, 调用 SDK API 通知开发者 playcompleted 回调
                callDeveloperPlayCompleted({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackENDCARDSHOWSUCCESS({
            expectCmptId,
            cb: ({id, data}) => {
                // endcard 展示成功时, 调用 SDK API 通知开发者 endcardshowsuccess 回调
                callDeveloperEndCardShowSuccess({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackCLICKED({
            expectCmptId,
            cb: ({id, data}) => {
                // clicked 时, 调用 SDK API 通知开发者 clicked 回调
                callDeveloperClicked({unitId, data})
            }
        })

        onComponentReactDeveloperCallbackDISMISSED({
            expectCmptId,
            cb: ({id, data}) => {
                // // type 4 类型广告被关闭, 调用 SDK API 通知开发者 dismissed 回调: data.convert // 1/2(成功/失败)
                // 二选一模板的关闭不再需要监听 SDK 发出的 "开发者回调事件", 而是在用户点击 endcard 阶段的关闭按钮时,
                //  直接调用开发者回调 "dismissed", 并在 SDK 返回成功时, 直接调用 Native 关闭方法 (operateComponent 402)
                // callDeveloperDismissed({unitId, data})
            }
        })
    }

    /**
     * 隐藏全屏 loading 提示
     */
    showPageLoading() {
        let DOMLoading = document.querySelector('.page-loading');
        if (DOMLoading && DOMLoading.style) DOMLoading.style.display = 'flex'
    }

    /**
     * 隐藏全屏 loading 提示
     */
    hidePageLoading() {
        let DOMLoading = document.querySelector('.page-loading');
        if (DOMLoading && DOMLoading.style) DOMLoading.style.display = 'none'
    }

    /**
     * SDK fireEvent webviewshow 时应该调用的逻辑
     */
    async show(res) {
        super.show(res)

        // webviewshow 时检查 SDK 传递过来的奖励信息, 如果符合要求则更新到上下文中, 并通知之前创建的两个播放模板组件设置此奖励信息
        this.setRewardInfoToSubTemplate(res);

        // 根据当前 webviewshow 时的时间戳更新 campaign 的 expired 标记
        this.updateCampaignExpiredState();

        // 检查所有 campaign 的 video 资源是否满足播放要求, 并根据检查结果执行不同的交互逻辑
        await this.recheckCampaignVideoReadyState();

    }

    /**
     * 检查所有 campaign 的 video 资源是否满足播放要求, 并根据检查结果执行不同的交互逻辑
     * @returns {Promise<void>}
     */
    async recheckCampaignVideoReadyState() {
        // webviewshow 时, 更新当前 campaign 列表所有 Video 的下载状态, 将满足播放要求的 video 所在 campaign 的 isReady 设置为 true
        await this.updateCampaignListVideoReadyState();
        // 从 campaign 列表中筛选出 ready 的 campaign
        let readyCampaignList = this.campaignList.filter(campaign => campaign.isReady)

        // >= 2 个 offer 的视频可以播放, 则更新对应 offer 的 ready 状态
        if (readyCampaignList.length >= 2) {
            console.warn('>= 2 个 offer 的视频可以播放')
            this.showAdSuccess({readyCampaignList})
        }

        // 如果 "只有一个 offer 的视频可以播放", 则通知 showsuccess 回调之后, 跳过二选一模板展示阶段, 直接播放视频
        else if (readyCampaignList.length === 1) {
            console.warn('"只有一个 offer 的视频可以播放"')
            this.showOneAdSuccess({readyCampaignList})
        }

            // 如果 "所有的 offer 的视频都无法播放", 则调用 SDK API 通知开发者 showfailed 回调
        // if (readyCampaignList.length <= 0)
        else {
            console.warn('所有的 offer 都没有满足 loading 条件, 无法播放视频, 调用 SDK API 通知开发者 showfailed 回调')
            this.showAdFailed({readyCampaignList})
        }
    }

    /**
     * webviewshow 时检查 SDK 传递过来的奖励信息, 如果符合要求则更新到上下文中, 并通知之前创建的两个播放模板组件
     * @param res webviewshow 时 SDK 传递过来的信息
     */
    setRewardInfoToSubTemplate(res) {
        if (res && res.param && typeof res.param.userId !== 'undefined' && typeof res.param.reward !== 'undefined') {
            this.updateSDKContext('reward', res.param.reward)
            this.updateSDKContext('userId', res.param.userId)
            this.tplIndexList.forEach(item => {
                let id = item.instanceId
                this.videoTplLegacy.setRewardInfo({id})
            })
        } else {
            console.warn('reward 信息更新失败, 后续无法发送给 SDK, 请检查')
        }
    }

    /**
     * H5在展示大模板的时候会有一个全局的标记，表示当前展示的所有offer是否expired，
     * 发onlyImp/offer imp等的时候参考这个，并且传递给sdk campaign等时候，标记这个offer是否expired
     *
     * expired: sdk load期间预加载大模板的时候告诉H5，同isReady一样，也只能表示开始渲染的时候是否超时，
     * H5在show的时候，应该根据timestamp自己计算offer是否过期，并在传递offer给sdk的时候，修改offer维度的expired
     */
    updateCampaignExpiredState() {
        let loadSuccessTimestamp = this.campaignList && this.campaignList[0] && this.campaignList[0].timestamp
        let campaignExpirationTime = loadSuccessTimestamp + this.appSetting.plct
        let webviewShowTime = Date.now()
        if (webviewShowTime > campaignExpirationTime) {
            this.campaignList.forEach(item => {
                item.expired = true
            })
        }
    }

    // 大模板被展示, 上报通知 SDK 上报 only impression
    reportOnlyImpression() {
        let campaign = this.campaignList && this.campaignList[0]
        let urlsWillReport = [{
            type: campaign && campaign.imp_ua,
            url: campaign && campaign.only_impression_url,
        }]
        console.warn({urlsWillReport})
        VideoBridgeReportUrls(urlsWillReport)
    }

    /**
     * 注册大模板页面元素用户交互事件监听
     * @returns {Promise<void>}
     */
    registerPageHandler() {

        // 注册二选一入口的点击事件
        window.mtg_fn_showVideoTemplateLegacy = async ({currentCampaignId = null}) => {
            return await this.appendAndPlayCurrentCampaign(currentCampaignId);
        }

    }

    /**
     * 根据提供的 campaign id, 播放对应的广告
     * @param currentCampaignId 要播放的 campaign
     * @returns {Promise<boolean>}
     */
    async appendAndPlayCurrentCampaign(currentCampaignId) {
        if (currentCampaignId != null) {

            // 如果当前 campaign 没有 ready, 则停止播放, 调用开发者回调 showfailed, 并且关闭当前广告
            let matchedCampaign = this.campaignList.filter(item => String(item.id) === String(currentCampaignId));
            console.log({currentCampaignId, matchedCampaign})
            this.currentCampaign = matchedCampaign && matchedCampaign[0]
            if (typeof this.currentCampaign === 'undefined' || this.currentCampaign.isReady !== true) {
                this.showAdFailed({currentCampaignId})
                return false
            }

            // 如果可以获取父视图 "大模板" 的实例, 则开始 addSubView
            this.currentChildTpl = this.childTplList.filter(item => item.campaignId === currentCampaignId)[0]
            if (this.bigTemplateInstanceId) {
                let addRes = await this.videoTplLegacy.append({
                    parentCmptId: this.bigTemplateInstanceId,
                    childCmptId: this.currentChildTpl.tplInstanceId
                }).catch(err => {
                    console.warn({err})
                })
                console.log({addRes})
            } else {
                console.warn('大模板实例获取失败', {bigTemplateInstanceId: this.bigTemplateInstanceId})
            }

        } else {
            console.warn('currentCampaignId 为空', {currentCampaignId})
        }
    }

    /**
     * 检查是否所有模板都已经 preload 成功
     * @returns {boolean}
     */
    allTplPreloadFinished() {
        let isAllFinished = true
        for (let curTplItem of this.childTplList) {
            if (curTplItem.isPageLoadFinished === false) {
                isAllFinished = false
            }
        }
        return isAllFinished
    }

    /**
     * 初始化页面通用组件
     */
    initComponents() {

    }

    /**
     * 调用自定义 hybrid 指令, 请确保此方法仅在开发场景中使用
     * @param fnName
     * @param params
     * @returns {Promise<void>}
     */
    async customCommand({fnName, params}) {
        return await customCommand({fnName, params})
    }

    /**
     * 对 campaign 中需要展示的部分信息进行格式化, 以满足模板展示需求
     * @param campaignList
     * @returns {any}
     */
    formatCampaignList(campaignList) {
        let campaignListTemp = JSON.parse(JSON.stringify(campaignList))
        campaignListTemp.forEach(item => {
            let rating = String(item.rating)
            item.rating = rating.indexOf('.') > -1 ? rating : (rating + '.0')
        })
        return campaignListTemp;
    }

    /**
     * webviewshow 时, 更新当前 campaign 列表所有 Video 的下载状态, 将满足播放要求的 video 所在 campaign 的 isReady 设置为 true
     * @returns {Object[]} SDK 返回的所有 video 的下载状态列表
     */
    async updateCampaignListVideoReadyState() {
        // 要获取的 File 类型为 video
        let type = 1
        let resource = this.campaignList.map(item => {
            let ref = item.video_url
            return {type, ref}
        })
        let videoDownloadStateRes = await VideoBridgeGetFileInfo({unitId: this.unitId, resource})
        console.warn('==--==', {videoDownloadInfoRes: videoDownloadStateRes})

        let videoDownloadStateList = videoDownloadStateRes && videoDownloadStateRes.resource
        this.campaignList && this.campaignList.forEach((item = {}) => {
            let videoUrl = item.video_url
            let videoSize = item.video_size
            let currentVideoDownloadState = videoDownloadStateList && videoDownloadStateList[videoUrl]

            if (currentVideoDownloadState) {
                // 如果 downloaded 标识为 1, 则表示当前视频已经下载完成
                if (currentVideoDownloadState.downloaded === 1) {
                    console.warn('如果 downloaded 标识为 1, 则表示当前视频已经下载完成')
                    item.isReady = true
                }
                // 如果 downloaded 标识无效, 则尝试判断下载的百分比是否满足 rate
                else if (videoSize > 0 && currentVideoDownloadState.videoDataLength / videoSize >= item.ready_rate) {
                    console.warn('如果 downloaded 标识无效, 则尝试判断下载的百分比是否满足 rate')
                    item.isReady = true
                }
            }
        })
    }

    showAdSuccess({readyCampaignList} = {}) {
        console.warn('大模板展示成功, 重新渲染大模板 UI, 发 showsuccess 回调, 上报 onlyImpression')

        console.log('---------- webviewshow 时, 重新渲染大模板静态 UI start ----------')
        // 渲染大模板静态 UI
        this.renderPageStaticUI({readyCampaignList})

        // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
        callDeveloperShowSucccess({unitId: this.unitId, data: {}})

        // 大模板被展示, 上报通知 SDK 上报 only impression
        this.reportOnlyImpression()
    }

    showOneAdSuccess({readyCampaignList} = {}) {
        console.warn('大模板展示被跳过, 不再渲染大模板 UI, 直接播放唯一可用的广告素材, 发 showsuccess 回调, 上报 onlyImpression')

        console.log('---------- webviewshow 时, 重新渲染大模板静态 UI start ----------')
        // 渲染大模板静态 UI
        this.renderPageStaticUI({readyCampaignList})

        // webviewshow 时直接播放当前唯一可用的广告, 不再展示大模板
        let currentCampaignId = readyCampaignList[0] && readyCampaignList[0].id
        this.appendAndPlayCurrentCampaign(currentCampaignId);

        // 大模板被展示时, 调用 SDK API 通知开发者 showsuccess 回调
        callDeveloperShowSucccess({unitId: this.unitId, data: {}})

        // 大模板被展示, 上报通知 SDK 上报 only impression
        this.reportOnlyImpression()
    }

    async showAdFailed({readyCampaignList, currentCampaignId}) {
        console.warn('大模板展示失败, 发 showfailed 回调, 并且关闭当前广告')

        callDeveloperShowFailed({unitId: this.unitId, data: {}})

        let id = currentCampaignId || this.campaignList && this.campaignList[0] && this.campaignList[0].id
        await this.videoTplLegacy.close({id})
    }
}